import { GiNotebook } from "react-icons/gi";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { LuHeartPulse } from "react-icons/lu";
import { SlGraduation } from "react-icons/sl";

import ServiceHero from "../../../components/elements/service-hero";
import FeatureStrip from "../../../components/elements/feature-strip";
import { PricingCardFlex } from "../../../components/elements/pricing-card";
import SectionTitle from "../../../components/elements/section-title";
import CTA from "../../../components/elements/CTA";
import "../ep-courses-and-services-pages.css";
import "./index-one-on-one-mentoring.css";

export default function MentoriasIndividuais() {
  const features = [
    ["♧", "Diagnóstico inicial"],
    ["▤", "Planejamento personalizado"],
    ["☏", "Acompanhamento contínuo"],
    ["◷", "Rotina de estudos e metas"],
    ["▥", "Evolução individual"],
  ];

  const featuresTemaAtuacaoSaude = [
    ["Educação em saúde"],
    ["Projetox acadêmico e científico"],
    ["Interface Saúde-Educação"],
    ["Processos secretos e residência"],
    ["Produção de artigos e trabalhos acadêmicos"],
    ["Desenvolvimento de propostas e disciplinas"],
    ["Planejamento de carreira na área de saúde"],
  ];

  const featuresTemaAtuacaoEducao = [
    ["Cameira docente"],
    ["Projetos de pesquisa TCC"],
    ["Processo seletivo (mestrado, doutorado, PND)"],
    ["Planejamento de estudos"],
    ["Organização da rotina acadêmica"],
    ["Construção de currículo e memorial"],
    ["Orientação para pós-graduação na área da educação"],
  ];

  return (
    <>
      <main>
        <ServiceHero
          eyebrow="MENTORIAS INDIVIDUAIS"
          title={
            <>
              Acompanhamento personalizado para sua <em>evolução.</em>
            </>
          }
          description="Um espaço de escuta, estratégia e acompanhamento para quem deseja construir uma trajetória acadêmica e profissional com mais clareza, propósito e direção."
          image="/images/mentorias-individuais.png"
          // quote="Juntos vamos mais longe!"
        />
        <div className="container service-body">
          <FeatureStrip
            items={features.map(([icon, label]) => ({ icon, label }))}
          />
          <div className="two-col mentor-grid" id="como-funciona">
            <section className="paper-panel">
              <SectionTitle title="Como funciona?" />
              <div className="mentoring-steps">
                {[
                  [
                    "01",
                    "Diagnóstico inicial",
                    "Avaliação do seu perfil, objetivos e dificuldades.",
                  ],
                  [
                    "02",
                    "Planejamento personalizado",
                    "Definição de metas, cronograma e estratégias de estudo.",
                  ],
                  [
                    "03",
                    "Acompanhamento contínuo",
                    "Encontros e orientações regulares.",
                  ],
                  [
                    "04",
                    "Resultados e evolução",
                    "Mais segurança, clareza e desempenho na sua escrita.",
                  ],
                ].map(([n, t, d]) => (
                  <div className="mentoring-step" key={n}>
                    <b>{n}</b>
                    <div>
                      <strong>{t}</strong>
                      <p>{d}</p>
                    </div>
                  </div>
                ))}
              </div>
              {/* <p className="hand-note">
                Cada trajetória é única. Vamos construir o seu caminho com
                estratégia e propósito.
              </p> Solicitado por ela*/}
            </section>
            <section className="paper-panel">
              <SectionTitle title="Nossos planos" />
              <div className="mentoring-pricing-list">
                <PricingCardFlex
                  title="Mentoria Avulsa"
                  tag="1 encontro / semana"
                  price="150,00"
                  unit="/ hora"
                  features={[
                    "Análise da sua demanda",
                    "Orientação personalizada",
                    "Definição de estratégias e próximos passos",
                    "Espaço para dúvidas e trocas",
                  ]}
                  message = "Mentoria Avulsa"
                />
                <PricingCardFlex
                  title="Pacote de Acompanhamento"
                  tag="3 encontros / semana"
                  // diagonalTag="Plano mais resultados" com pedido 
                  price="400,00"
                  unit="/ hora"
                  features={[
                    "3 encontros de 1 hora",
                    "Acompanhamento durante o periodo",
                    "Orientação continua e direcionada",
                    "Suporte por mensagem (WhatsApp ou e-mail)",
                  ]}
                  featured
                />
              </div>
            </section>
          </div>
          <section className="why">
            <SectionTitle align="center" title="Ideal para quem busca:" />
            <div className="why-grid four">
              {[
                "Organização e foco nos estudos",
                "Aprimorar a escrita e a argumentação",
                "Preparação para ENEM, vestibulares e concursos",
                "Mais confiança e segurança",
              ].map((x, i) => (
                <div key={i}>
                  <b>{["◷", "▤", "♧", "♢"][i]}</b>
                  <span>{x}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="demandas-especificas">
            <div className="demandas-especificas-left">
              <GiNotebook className="demandas-especificas-icon" />
              <div className="descricao-demandas">
                <h4>Demandas Especificas</h4>
                <p>
                  Projetos, artigos, editais, análises de documentos e cutras
                  demandas que determinam leitura prévia podem ter orçamento
                  personalizado.
                </p>
              </div>
            </div>

            <div className="estrategia-proposito">
              <p>
                "Cada trajetória é única. Vamos construir seu caminho com
                estratégia e propósito."
              </p>
            </div>
          </section>

          <section className="mentoria-tema-atuacao">
            <h5 className="p-test">PRINCIPAIS TEMAS DE ATUAÇÃO</h5>
            <div className="principais-tema-atuacao">
              <div className="flex principais-tema-atuacao-left principais-tema-atuacao-content">
                <div className="principais-tema-atuacao-icon">
                  <SlGraduation />
                </div>
                <div>
                  <p>EDUCAÇÃO</p>
                  <ul className="correction-check-list">
                    {featuresTemaAtuacaoEducao.map((feature) => (
                      <li key={feature}>
                        <IoIosCheckmarkCircleOutline className="ep-icon-check-mark" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="flex principais-tema-atuacao-content">
                <div className="principais-tema-atuacao-icon">
                  <LuHeartPulse  />
                </div>
                
                <div>
                  <p>SAÚDE</p>
                  <ul className="correction-check-list">
                    {featuresTemaAtuacaoSaude.map((feature) => (
                      <li>
                        <IoIosCheckmarkCircleOutline className="ep-icon-check-mark" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <p className="p-test">
              "Ideias, planos e conquistas também precisam de orientação."
            </p>
          </section>

          <CTA
            title="Sua evolução começa com um passo, o primeiro contato."
            subtitle="Vamos conversar sobre seus objetivos?"
            button="QUERO AGENDAR MINHA MENTORIA"
            href=""
          />
        </div>
      </main>
    </>
  );
}
